import { Box } from '@mui/material';
import PublishedAdsTable from './PublishedAdsTable';

const PublishedAds = () => {
	return (
		<Box className="mb-14 w-full">
			<PublishedAdsTable />
		</Box>
	);
};

export default PublishedAds;
